import { Component, Input } from '@angular/core';

import {
  IconName,
  TooltipPosition,
  IconComponent,
  IconToken,
  RtTooltip,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-feature-item',
  templateUrl: './feature-item.component.html',
  styleUrls: ['./feature-item.component.less'],
  imports: [RtTooltip, IconComponent],
})
export class FeatureItemComponent {
  @Input() public label: string;
  @Input() public tooltip?: string;
  @Input() public isBold?: boolean;

  @Input() public set icon(value: IconName | undefined) {
    this._icon = value || 'check';
  }
  public get icon(): IconName {
    return this._icon;
  }

  @Input() public set tooltipPosition(value: TooltipPosition | undefined) {
    this._tooltipPosition = value || 'right';
  }
  public get tooltipPosition(): TooltipPosition {
    return this._tooltipPosition;
  }

  public get iconColor() {
    return this.icon === 'add-circle-outline'
      ? <IconToken>'colorIconSuccessDefault'
      : 'colorIconStrongDefault';
  }

  private _icon: IconName = 'check';
  private _tooltipPosition: TooltipPosition = 'right';
}
